import classes from './ChartPanel.module.scss';
import { PanelHeader } from '../../../components/containers/Panel/PanelHeader.view';
import { Loader } from '../../../components/containers/Loader';
import React, { useContext } from 'react';
import { Panel } from '../../../components/containers/Panel';
import { WithChildren } from '../../../models/children-props';
import { AnalyticsContext } from '../AnalyticsProvider';
import { EmptyScreen } from '../LineChart/EmptyScreen';

type ChartPanelViewProps = WithChildren & {
  loading: boolean;
  chartTitle: string;
  chartSubtitle: string;
  subTitleTooltipText: string;
  isEmpty: boolean | undefined;
};
export const ChartPanelView = ({
  children,
  loading,
  chartTitle,
  chartSubtitle,
  subTitleTooltipText,
  isEmpty
}: ChartPanelViewProps) => {
  const { selectedProfilesIds } = useContext(AnalyticsContext);
  return (
    <Panel customClass={classes.ChartContainer}>
      <div className={'margin-top-small-8'}>
        <PanelHeader title={chartTitle} subTitle={chartSubtitle} subTitleTooltip={subTitleTooltipText} isChartPanel />
      </div>
      {loading && (
        <div className={classes.LoaderContainer}>
          <Loader variation={'dark'} size={'large'} />
        </div>
      )}
      {isEmpty && !loading && <EmptyScreen noProfiles={selectedProfilesIds.length === 0} />}
      {!isEmpty && !loading && children}
    </Panel>
  );
};
